import type { RefObject } from "react";
import type { HandshakeSessionDetail } from "@/types";
import { HandshakeAdminPartnerComposer } from "./HandshakeAdminPartnerComposer";
import { HandshakeAuditPanel } from "./HandshakeAuditPanel";
import { HandshakeCancelSessionModal } from "./HandshakeCancelSessionModal";

type AdminSessionPanelVariant = "embedded" | "page" | "flush";

interface HandshakeAdminSessionPanelProps {
  session: HandshakeSessionDetail;
  variant: AdminSessionPanelVariant;
  canCancel: boolean;
  canSendMessage: boolean;
  isSending: boolean;
  isCancelling: boolean;
  onSend: (content: string) => Promise<void>;
  onCancelRequest: () => void;
  messagesEndRef: RefObject<HTMLDivElement | null>;
  showCancelConfirm: boolean;
  onCloseCancelConfirm: () => void;
  cancelSession: () => Promise<boolean>;
}

export function HandshakeAdminSessionPanel({
  session,
  variant,
  canCancel,
  canSendMessage,
  isSending,
  isCancelling,
  onSend,
  onCancelRequest,
  messagesEndRef,
  showCancelConfirm,
  onCloseCancelConfirm,
  cancelSession,
}: HandshakeAdminSessionPanelProps) {
  return (
    <>
      <HandshakeAuditPanel
        session={session}
        variant={variant}
        canCancel={canCancel}
        isCancelling={isCancelling}
        onCancel={onCancelRequest}
        messagesEndRef={messagesEndRef}
        messageComposer={
          <HandshakeAdminPartnerComposer
            session={session}
            canSend={canSendMessage}
            isSending={isSending}
            onSend={onSend}
          />
        }
      />
      <HandshakeCancelSessionModal
        isOpen={showCancelConfirm}
        onClose={onCloseCancelConfirm}
        cancelSession={cancelSession}
        isLoading={isCancelling}
      />
    </>
  );
}
